// extracted by mini-css-extract-plugin
export default {"logoIcon":"Logo_logoIcon__AFIxU"};